import { Contract } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import i18next from 'i18next';
import middleware from 'middleware';
import { useEffect } from 'react';
import {
  useGetMerchDistributionSectionTemplate,
  useGetMerchDistributionTemplateLightList,
} from 'services/templates/merch-distribution-template';
import { TEMPLATE_TYPE } from 'services/templates/types';
import { addItem, getExtremeId } from 'utils/dnd/dndUtilities';

const ContractSideMenuMerchDistribution = () => {
  const { values, setFieldValue, namePrefix, setErrors } = useFormikContractHelpers();

  const merchDistributionLightList = useGetMerchDistributionTemplateLightList();

  const selectedId = values.sideMenu?.customTemplate?.selectedId;

  const parentId = values.sideMenu?.customTemplate?.parentId;

  const merchDistributionTemplate = useGetMerchDistributionSectionTemplate(
    selectedId ?? '',
    {
      notFoundPath: undefined,
      notFoundToastError: i18next.t('toast-message.not-found'),
    },
    !!selectedId,
    false
  );

  useEffect(() => {
    if (!!selectedId && merchDistributionTemplate.data && parentId) {
      const contractTemplateForm =
        middleware.template.merchDistribution.queryToForm(
          merchDistributionTemplate.data,
          `${parseInt(getExtremeId(values.items)) + 1}`
        );

      const merchDistribution = contractTemplateForm[0].children[0];

      if (contractTemplateForm) {
        setFieldValue(
          namePrefix,
          addItem(values.items, parentId, merchDistribution)
        );
        setFieldValue('sideMenu', undefined);
        setErrors({})
      }
      console.log(
        'useEffect - merchDistributionTemplate',
        selectedId,
        merchDistributionTemplate.data
      );
    }
  }, [selectedId, merchDistributionTemplate.data]);

  return (
    <Contract.SideMenu.TemplatesList.Wrapper
      templates={merchDistributionLightList.data}
      templateType={TEMPLATE_TYPE.merchDistribution}
      item={template => (
        <Contract.SideMenu.TemplatesList.ListItem
          key={template.id}
          template={template}
        />
      )}
    />
  );
};

export default ContractSideMenuMerchDistribution;
